import { Injectable } from '@angular/core';
import { ClientPageInfo } from 'projects/apex/src/app/models/client-page-info';
import { APIService } from 'projects/apex/src/app/services/http/http.service';

@Injectable()
export class ClientPageInfoService extends APIService<ClientPageInfo> {
  route = 'client-page-info';
}
